import styled from 'styled-components'
import { print } from '../styles'
import {
  compose,
  space,
  layout,
  typography,
  color,
  background,
  border,
  shadow,
} from 'styled-system'

const CardTableFootCell = styled.td`
  ${print}
  ${compose(
    space,
    typography,
    color,
    layout,
    background,
    border,
    shadow,
  )}

  &:not(:first-child):not(:last-child) {
    border-radius: 0;
  }

  &:first-child:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  &:last-child:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`

CardTableFootCell.defaultProps = {
  fontSize: 'medium',
  borderRadius: 'small',
  py: 'medium',
  bg: 'secondary.1',
}

export default CardTableFootCell
